<template>
  <div class="container">
    <div class="detail-content mb-30">
      <div class="detail-content-header">
        <p class="fs-20">{{ detailInfo.title }}</p>
        <p class="color-999 mt-20">发布时间：{{ detailInfo.releaseTime }} &nbsp;&nbsp; 点击量: {{ detailInfo.views }}</p>
      </div>
      <div class="detail-content-body not-reset" v-html="detailInfo.content" />
    </div>
  </div>
</template>

<script>
import infoApi from "@/api/information"
import { parseTime } from "@/filters";

export default {
  name: "CodeDetail",
  components: {},
  props: {
  },
  data() {
    return {
      detailInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 获取列表
    getList() {
      infoApi.page({
        pageNo: 1,
        pageSize: 1,
        columnId: this.$getMenuIdByCode(this.$route.params.code),
        title: this.title
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          if (list.length > 0) {
            this.getDetail(list[0].id)
          }
        }
      })
    },
    // 获取详情
    getDetail(id) {
      infoApi.detail(id).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          data.releaseTime = parseTime(data.releaseTime, "{y}-{m}-{d}")
          this.detailInfo = data
          this.$store.commit("permission/SET_DETAIL_TITLE", data.title)
          // 更新查看
          infoApi.updateView(id)
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
  .detail-content{
    background-color: #fff;
    padding: 0 20px;
    border: 1px solid #ddd;
    .detail-content-header{
      height: 136px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .detail-footer{
    height: 50px;
  }
  .pre-page, .next-page{
    width: 48%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
